<template>
  <div>
    <bg-button
      @click="$refs.file.click()"
      :text="hasFile ? 'Upload new file' : 'Upload File'"
      postIcon="file"
      :isLoading="loading"
    />
    <span v-if="hasFile && showFileName" style="margin-left: 10px"
      >Current file: {{ getFilename(filename) }}</span
    >
    <input
      type="file"
      name="fileUpload"
      ref="file"
      style="display: none"
      @change="onFileChange"
    />
  </div>
</template>

<script type="text/babel">
import BgButton from "@/components/bg-button";
export default {
  name: "fileupload",
  components: {
    BgButton,
  },
  props: {
    uploaded: {
      type: Boolean,
    },
    handleFileChange: {
      type: Function,
    },
    filename: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    buttonReuploadText: {
      type: String,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showFileName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file: null,
      hasFile: this.uploaded,
      loading: false,
      showName: this.showFileName,
    };
  },
  watch: {
    isLoading(val) {
      this.loading = val;
    },
  },
  methods: {
    onFileChange(e) {
      let vm = this;
      this.file = e.target.files[0];
      this.hasFile = true;
      this.handleFileChange(this.file);
    },
    getFilename(url) {
      //first check if there is a file just uploaded
      if (this.file !== null) {
        return this.file.name;
      }
      if (url && url !== "/videos/fallback/default.mp4") {
        return url.split("/").pop().split("?")[0];
      }
      return "";
    },
  },
};
</script>
